import { PageLayout } from '../components/Layout';
import { Link } from 'react-router-dom';
import { Heart, ArrowLeft, ShieldCheck, Warning, Handshake, UserCircle, XCircle, Scales } from '@phosphor-icons/react';

const RefundPolicy = () => {
  return (
    <PageLayout>
      <div className="py-12 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-6">
              <Scales weight="light" className="w-8 h-8 text-primary" />
            </div>
            <h1 className="font-serif text-4xl md:text-5xl mb-4">Client Service Agreement</h1>
            <p className="text-muted-foreground">
              Link, Laugh & Love Matchmaking
            </p>
            <p className="text-sm text-muted-foreground mt-2">Last Updated: December 2025</p>
          </div>

          {/* Age Requirement Banner */}
          <div className="bg-primary/10 rounded-lg p-4 text-center mb-8">
            <p className="text-primary font-semibold">
              YOU MUST BE 21+ YEARS OLD TO APPLY FOR LINK, LAUGH & LOVE MATCHMAKING SERVICES
            </p>
          </div>

          {/* Content */}
          <div className="paper-card rounded-lg p-8 md:p-12 space-y-8">
            
            {/* Section 1: Services */}
            <section>
              <h2 className="font-serif text-2xl mb-4 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center text-sm">1</span>
                Services
              </h2>
              <p className="text-muted-foreground leading-relaxed">
                Link, Laugh & Love provides personalized matchmaking and relationship advice & support. 
                Services are confidential, selective and customized. Link, Laugh & Love reserves the right 
                to refuse or terminate service at its discretion.
              </p>
            </section>

            {/* Section 2: Payment Terms */}
            <section>
              <h2 className="font-serif text-2xl mb-4 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center text-sm">2</span>
                Payment Terms
              </h2>
              <div className="bg-pink-50 rounded-lg p-6 border-l-4 border-primary">
                <p className="text-gray-700 leading-relaxed">
                  Fees must be paid in full before services begin. <strong>Fees are NON-REFUNDABLE.</strong> Client 
                  agrees not to dispute or reverse charges once services are purchased.
                </p>
              </div>
            </section>

            {/* Section 3: No Guarantee */}
            <section>
              <h2 className="font-serif text-2xl mb-4 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center text-sm">3</span>
                No Guarantee
              </h2>
              <p className="text-muted-foreground mb-4">
                Clients understand matchmaking is subjective. Link, Laugh & Love <strong>DOES NOT GUARANTEE:</strong>
              </p>
              <ul className="space-y-2 text-muted-foreground">
                <li className="flex items-center gap-2">
                  <Warning weight="fill" className="w-4 h-4 text-amber-500" />
                  Matches
                </li>
                <li className="flex items-center gap-2">
                  <Warning weight="fill" className="w-4 h-4 text-amber-500" />
                  Relationships
                </li>
                <li className="flex items-center gap-2">
                  <Warning weight="fill" className="w-4 h-4 text-amber-500" />
                  Compatibility
                </li>
                <li className="flex items-center gap-2">
                  <Warning weight="fill" className="w-4 h-4 text-amber-500" />
                  Marriage
                </li>
                <li className="flex items-center gap-2">
                  <Warning weight="fill" className="w-4 h-4 text-amber-500" />
                  Emotional connection
                </li>
              </ul>
            </section>

            {/* Section 4: Client Responsibilities */}
            <section>
              <h2 className="font-serif text-2xl mb-4 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center text-sm">4</span>
                Client Responsibilities
              </h2>
              <p className="text-muted-foreground mb-4">Client agrees to:</p>
              <ul className="space-y-2 text-muted-foreground">
                <li className="flex items-center gap-2">
                  <ShieldCheck weight="fill" className="w-4 h-4 text-green-500" />
                  Provide truthful information
                </li>
                <li className="flex items-center gap-2">
                  <ShieldCheck weight="fill" className="w-4 h-4 text-green-500" />
                  Act respectfully and safely
                </li>
                <li className="flex items-center gap-2">
                  <ShieldCheck weight="fill" className="w-4 h-4 text-green-500" />
                  Participate actively
                </li>
                <li className="flex items-center gap-2">
                  <ShieldCheck weight="fill" className="w-4 h-4 text-green-500" />
                  Maintain communication
                </li>
              </ul>
            </section>

            {/* Section 5: Termination */}
            <section>
              <h2 className="font-serif text-2xl mb-4 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center text-sm">5</span>
                Termination
              </h2>
              <p className="text-muted-foreground mb-4">
                Link, Laugh & Love may terminate services immediately for:
              </p>
              <ul className="space-y-2 text-muted-foreground">
                <li className="flex items-center gap-2">
                  <XCircle weight="fill" className="w-4 h-4 text-red-500" />
                  Harassment or unsafe behavior
                </li>
                <li className="flex items-center gap-2">
                  <XCircle weight="fill" className="w-4 h-4 text-red-500" />
                  Dishonesty
                </li>
                <li className="flex items-center gap-2">
                  <XCircle weight="fill" className="w-4 h-4 text-red-500" />
                  Non-cooperation
                </li>
                <li className="flex items-center gap-2">
                  <XCircle weight="fill" className="w-4 h-4 text-red-500" />
                  Policy violation
                </li>
              </ul>
            </section>

            {/* Section 6: Liability Waiver */}
            <section>
              <h2 className="font-serif text-2xl mb-4 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center text-sm">6</span>
                Liability Waiver
              </h2>
              <p className="text-muted-foreground mb-4">
                Link, Laugh & Love is not responsible for:
              </p>
              <ul className="space-y-2 text-muted-foreground mb-4">
                <li className="flex items-center gap-2">
                  <span className="text-primary">•</span>
                  Client interactions
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-primary">•</span>
                  Emotional outcomes
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-primary">•</span>
                  Personal decisions
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-primary">•</span>
                  Actions of matches
                </li>
              </ul>
              <p className="text-muted-foreground italic">
                Clients participate voluntarily and assume all risks.
              </p>
            </section>

            {/* Section 7: Agreement Acceptance */}
            <section>
              <h2 className="font-serif text-2xl mb-4 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center text-sm">7</span>
                Agreement Acceptance
              </h2>
              <div className="bg-gradient-to-r from-primary/10 to-pink-50 rounded-lg p-6">
                <p className="text-gray-700 leading-relaxed mb-4">
                  By signing below or purchasing services, client confirms they have read, understood and agreed to 
                  <strong> ALL terms</strong>. Your privacy is protected and your information remains confidential. 
                  Link, Laugh & Love does not conduct client background check/information. False information or 
                  misconduct may result in immediate termination without refund.
                </p>
                <p className="text-primary font-semibold">
                  No refunds will be issued.
                </p>
              </div>
            </section>

            {/* Contact Section */}
            <section className="border-t border-pink-200 pt-8">
              <h2 className="font-serif text-xl mb-3">Questions?</h2>
              <p className="text-muted-foreground mb-4">
                If you have any questions about this agreement, please don't hesitate to reach out.
              </p>
              <div className="flex flex-wrap gap-4 text-sm">
                <a href="mailto:LinkLaughLoveMatch@gmail.com" className="text-primary hover:underline">
                  LinkLaughLoveMatch@gmail.com
                </a>
                <a href="tel:8107991060" className="text-primary hover:underline">
                  (810) 799-1060
                </a>
              </div>
            </section>
          </div>

          <div className="text-center mt-8">
            <Link to="/" className="inline-flex items-center gap-2 text-primary hover:underline">
              <ArrowLeft className="w-4 h-4" />
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default RefundPolicy;
